import React, { useContext, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import { useAccount } from 'wagmi';
import { StakingContext } from '../../contexts/StakingContext';
import { ActiveStakes, GlobalStakes, KYCBanner } from './components';
import { no_decimals } from '../../helpers';

import deposit from './assets/deposit.png';
import multiplier from './assets/multiplier.png';
import receive from './assets/receive.png';
import book from './assets/book-nft.png';
import { ReactComponent as OpenSea } from './assets/opensea.svg';
import { ReactComponent as SP } from './assets/deposit.svg';
import { ReactComponent as MAS } from './assets/user.svg';

import './landing.scss';


const blockpassUrl = "https://verify-with.blockpass.org/?clientId=open_campus_0027e&serviceName=OpenCampus&env=prod";


export function StakingLanding() {
    const {
        status, fetchedKYC
    } = useContext(StakingContext);
    const { status: ready } = useAccount();

    return <div id="staking-landing">
        <KYCBanner status={status} fetchedKYC={fetchedKYC} connected={ready == "connected"} />
        <Overview />
        <StakingPools />
        <BuyPNFT />
    </div>
}

function Overview() {
    const {
        royaltiesGenerated, eduDistributed
    } = useContext(StakingContext);

    return <section id="hero">
        <Container>
        <div>
            <h1>YIELD $EDU BY STAKING YOUR PUBLISHER NFTS</h1>
            <h4>Stake your pNFTs, earn $EDU tokens, and support the creation and distribution of educational content globally</h4>
        </div>
        <div className='overview-info'>
            <Row>
                {/* <Col>
                    <h2>-</h2>
                    <h5>pNFTs locked</h5>
                </Col> */}
                {/* <Col>
                    <h2>{!royaltiesGenerated ? '-' : usd.format(royaltiesGenerated)} USD</h2>
                    <h5>Royalties Generated</h5>
                </Col> */}
                {/* <Col>
                    <h2>-</h2>
                    <h5>Genesis NFT Locked</h5>
                </Col> */}
                <Col>
                    <h2>{!eduDistributed ? '-' : no_decimals.format(eduDistributed)}</h2>
                    <h5>$EDU Distributed</h5>
                </Col>
                <Col>
                    <h2>12.3x</h2>
                    <h5>Max Multipier</h5>
                </Col>
            </Row>
        </div>
        <div id="how-it-works">
            <h3>How staking works</h3>
            <Row>
                <Col>
                    <img src={deposit} width="305px" />
                    <div>
                        <p className='ocBlue'><b>Deposit pNFT</b></p>
                        <p>Stake your publisher NFT to start accumulating boosted $EDU yield</p>
                    </div>
                </Col>
                <Col>
                    <img src={multiplier} width="305px" />
                    <div>
                        <p className='ocBlue'><b>Increase multiplier with genesis NFT</b></p>
                        <p>Pair your pNFT with Genesis NFT in order to qualify for staking boosted yield</p>
                    </div>
                </Col>
                <Col>
                    <img src={receive} width="305px" />
                    <div>
                        <p className='ocBlue'><b>Receive $EDU</b></p>
                        <p>Total flexibility on what to do with your $EDU reward. Withdraw any time with no penalty</p>
                    </div>
                </Col>
            </Row>
        </div>
        </Container>
    </section>
}

const ll = 'https://userdocs.opencampus.xyz/other-open-campus-assets/publisher-nfts/publisher-nft-staking'

function StakingPools() {
    const navigate = useNavigate();
    const { address, status: ready } = useAccount();
    const { status, fetchedKYC } = useContext(StakingContext);

    return <section id="staking-pools">
        <Container>
            <KYCDisclaimer status={status} fetched={fetchedKYC} connected={ready == "connected"} />

            <h3>Staking Pools</h3>
            <p>Maximize Your pNFT Potential: Dive in to explore potential boosted reward, oversee every staked NFT, and track the $EDU tokens they are accruing. Effortlessly manage the status of each staked NFT to ensure optimal returns. <a href={ll} target="_blank">Learn more here</a></p>
            <div className='oc-table'>

                <Tab.Container id="sp-panel" defaultActiveKey="pools">
                <Row>
                    <Col sm={2}>
                    <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                        <Nav.Link eventKey="pools"><SP /> Staking Pools</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link eventKey="my"><MAS /> My Active Stakes</Nav.Link>
                        </Nav.Item>
                    </Nav>
                    </Col>
                    <Col sm={10}>
                    <Tab.Content>
                        <Tab.Pane eventKey="pools">
                            <GlobalStakes />
                        </Tab.Pane>
                        <Tab.Pane eventKey="my">
                            <ActiveStakes />
                        </Tab.Pane>
                    </Tab.Content>
                    </Col>
                </Row>
                </Tab.Container>
            </div>

            <div className='action-panel'>
                <div className='ctrls'>
                    {
                        ready == "connected" && address
                        ? <>
                            <Button onClick={() => navigate('/staking/claim')} variant='oc-primary'>Claim Reward</Button>
                            <Button onClick={() => navigate('/staking/stake')} variant='oc-primary'>Stake your Publisher NFTs now</Button>
                        </>
                        : null
                    }
                </div>
            </div>
        </Container>
    </section>
}

function KYCDisclaimer(props) {
    const { status, fetched, connected } = props;

    if(fetched && !status && connected) return <div>
        <p style={{color: '#EB1414', textAlign: 'center'}}>Note: You must pass the KYC process in order to claim rewards or royalties from staking. You can <a href={blockpassUrl} target="_blank" style={{color: '#EB1414', textDecoration: 'underline'}}>start the process here</a> or complete it later.</p>
    </div>

    return <></>
}

function BuyPNFT() {
    return <section id="buy-pnft">
        <Container>
        <Row>
            <Col>
                <img src={book} width="360" />
                <h1>Buy Open Campus Publisher NFTs now on <span style={{color: '#ABAFD9'}}>major secondary markets</span></h1>
            </Col>
            <Col>
                <p>Embark on a rewarding journey with Open Campus Publisher NFTs (pNFTs) and become a pivotal part of global education empowerment! By owning a pNFT, you're not just upholding the creation and distribution of invaluable educational content, but also unlocking the door to exciting rewards through staking and revenue sharing.</p>
                <Button variant='oc-primary' href='https://opensea.io/collection/open-campus-publisher-nft-season-2' target='blank'>Buy Publisher NFT on Open Sea <OpenSea /></Button>
            </Col>
        </Row>
        </Container>
    </section>
    
}